// extracted by mini-css-extract-plugin
export default {"exceptionLayout":"ExceptionLayout_exceptionLayout__vjUoc"};